import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'

export const contactChannels = {
  CHAT: 'chat',
  CTA: 'cta',
  EMAIL: 'email',
  PHONE: 'phone',
} as const

export const contactLinkTypes = {
  AS_PORTAL: 'as_portal',
  FAQ: 'faq',
  ORDER_RETURN_LINK: 'order_return',
  ORDER_STATUS: 'order_status',
  REPORT_FAKE_LINK: 'report_fake',
  STELLA_FAQ: 'stella_faq',
  SUPERNOVA_FAQ: 'supernova_faq',
  WARRANTY: 'warranty',
} as const

export const imageFormats = ['image/png', 'image/jpg'] as const
export const inputFileValidFormats = ['application/pdf', ...imageFormats] as const

export const EMEACountry = [
  WcsStoreId.BELGIUM,
  WcsStoreId.DENMARK,
  WcsStoreId.FRANCE,
  WcsStoreId.GERMANY,
  WcsStoreId.IRELAND,
  WcsStoreId.ITALY,
  WcsStoreId.NETHERLANDS,
  WcsStoreId.NORWAY,
  WcsStoreId.POLAND,
  WcsStoreId.PORTUGAL,
  WcsStoreId.SPAIN,
  WcsStoreId.SWITZERLAND,
  WcsStoreId.AUSTRIA,
  WcsStoreId.SWEDEN,
  WcsStoreId.UNITED_KINGDOM,
] as const

const NA_LATAMCountries = [WcsStoreId.USA, WcsStoreId.CANADA, WcsStoreId.MEXICO, WcsStoreId.BRAZIL]

const ASIAN_COUNTRIES = [WcsStoreId.CHINA, WcsStoreId.HONG_KONG, WcsStoreId.KOREA]

export const countriesWithChat = [
  ...EMEACountry,
  ...NA_LATAMCountries,
  ...ASIAN_COUNTRIES,
  WcsStoreId.AUSTRALIA,
  WcsStoreId.JAPAN,
] as const

export const phoneVisibleCountryList = [
  ...EMEACountry,
  ...ASIAN_COUNTRIES,
  WcsStoreId.AUSTRALIA,
  WcsStoreId.JAPAN,
] as const
export const fileAttachmentVisibleCountryList = [
  ...EMEACountry,
  ...ASIAN_COUNTRIES,
  WcsStoreId.FINLAND,
  WcsStoreId.AUSTRALIA,
  WcsStoreId.JAPAN,
] as const
export const countriesWithTwothousandDigitsInTopic = [
  ...EMEACountry,
  ...ASIAN_COUNTRIES,
  WcsStoreId.FINLAND,
  WcsStoreId.AUSTRALIA,
  WcsStoreId.JAPAN,
] as const
export const countriesWithMandatoryNameAndSurnameField = [
  ...EMEACountry,
  ...ASIAN_COUNTRIES,
  WcsStoreId.FINLAND,
  WcsStoreId.AUSTRALIA,
  WcsStoreId.JAPAN,
] as const
